export function getTagsString(tags) {
  let tagString = tags.reduce((tagString, menuTag) => {
    return tagString + "|" + menuTag;
  }, "");
  if (tagString[0] === "|") {
    return tagString.substr(1, tagString.length - 1);
  }
  if (tagString === "") {
    return null;
  }
  return tagString;
}
